import { createAction } from '@reduxjs/toolkit';

export const fetchUserDetails=createAction<number>('FETCH_USER_DETAILS_INIT');
export const fecthUserDetailsSuccess=createAction<any>('FETCH_USER_DETAILS_SUCCESS');
export const fecthUserDetailsFailed=createAction('FETCH_USER_DETAILS_FAILED');